/* Dalen — Popular Items section.
   - Hides Dawn's below-slider control bar (handled by CSS).
   - Injects custom green rounded-square arrows on either side of the slider.
     They programmatically click Dawn's (hidden) prev/next buttons so all of
     Dawn's scroll, snap, and disabled-state logic continues to work.
   - Injects dot pagination below the slider tied to Dawn's slideChanged event. */
(function () {
  // Match the arrow used in .dalen-cats__card-tag (straight shaft + head)
  var ARROW_RIGHT = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M1 8h12M8 3l5 5-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_LEFT  = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" style="transform:scaleX(-1)"><path d="M1 8h12M8 3l5 5-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function findSection() {
    // Shopify renders IDs as shopify-section-template--<hash>__<key>
    // We match on the trailing "__popular_items" suffix, or the plain id.
    return (
      document.querySelector('[id$="__popular_items"]') ||
      document.getElementById('shopify-section-popular_items')
    );
  }

  function init() {
    var section = findSection();
    if (!section) return;
    if (section.dataset.dalenDotsReady) return;

    var sliderComp = section.querySelector('slider-component');
    if (!sliderComp) return;

    var slider = sliderComp.querySelector('.slider');
    var slides = sliderComp.querySelectorAll('[id^="Slide-"]');
    var dawnPrev = sliderComp.querySelector('.slider-button--prev');
    var dawnNext = sliderComp.querySelector('.slider-button--next');
    if (!slider || !slides.length) return;

    // ---- Custom side arrows ----
    section.querySelectorAll('.dalen-arrow').forEach(function (n) { n.remove(); });

    function buildArrow(direction) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dalen-arrow dalen-arrow--' + direction;
      btn.setAttribute('aria-label', direction === 'prev' ? 'Previous products' : 'Next products');
      btn.innerHTML = direction === 'prev' ? ARROW_LEFT : ARROW_RIGHT;
      btn.addEventListener('click', function () {
        var target = direction === 'prev' ? dawnPrev : dawnNext;
        if (target && !target.hasAttribute('disabled')) target.click();
      });
      return btn;
    }

    var prevBtn = buildArrow('prev');
    var nextBtn = buildArrow('next');
    sliderComp.appendChild(prevBtn);
    sliderComp.appendChild(nextBtn);

    // Mirror Dawn's disabled state onto our buttons whenever the slider updates
    function syncArrowState() {
      if (dawnPrev) prevBtn.toggleAttribute('disabled', dawnPrev.hasAttribute('disabled'));
      if (dawnNext) nextBtn.toggleAttribute('disabled', dawnNext.hasAttribute('disabled'));
    }
    syncArrowState();

    function computeTotalPages() {
      if (slides.length < 2) return slides.length;
      var first = slides[0];
      var second = slides[1];
      var offset = second.offsetLeft - first.offsetLeft;
      if (!offset) return slides.length;
      var slidesPerPage = Math.round((slider.clientWidth - first.offsetLeft) / offset);
      return Math.max(1, slides.length - slidesPerPage + 1);
    }

    function build(totalPages) {
      // Remove existing dots if any (e.g. on rebuild)
      var existing = section.querySelector('.dalen-dots');
      if (existing) existing.remove();
      if (totalPages < 2) return null;

      var container = document.createElement('div');
      container.className = 'dalen-dots';
      container.setAttribute('role', 'tablist');
      container.setAttribute('aria-label', 'Slide navigation');

      var dots = [];
      for (var i = 0; i < totalPages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dalen-dots__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.setAttribute('role', 'tab');
        dot.dataset.page = String(i + 1);
        dot.addEventListener('click', onDotClick);
        dots.push(dot);
        container.appendChild(dot);
      }
      // Append dots inside slider-component so they share its positioning
      // context with the side arrows (both can be absolutely positioned at the
      // bottom of the slider on mobile).
      sliderComp.appendChild(container);
      return { container: container, dots: dots };
    }

    function onDotClick(e) {
      var page = parseInt(e.currentTarget.dataset.page, 10);
      var target = slides[page - 1];
      if (!target) return;
      slider.scrollTo({
        left: target.offsetLeft - slides[0].offsetLeft,
        behavior: 'smooth'
      });
    }

    var built = build(computeTotalPages());
    if (!built) return;
    var dots = built.dots;

    sliderComp.addEventListener('slideChanged', function (e) {
      var current = e.detail && e.detail.currentPage;
      if (!current) return;
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i + 1 === current);
      });
      syncArrowState();
    });

    // Also sync on scroll-end in case the user swipes/scrolls without clicking
    slider.addEventListener('scroll', function () {
      requestAnimationFrame(syncArrowState);
    }, { passive: true });

    // Rebuild dot count if viewport size changes the slides-per-page calc
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var nextTotal = computeTotalPages();
        if (nextTotal === dots.length) return;
        var rebuilt = build(nextTotal);
        if (rebuilt) dots = rebuilt.dots;
      }, 200);
    });

    section.dataset.dalenDotsReady = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // slider-component is a custom element — small delay to ensure connected
    setTimeout(init, 50);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && /__popular_items$/.test(e.target.id || '')) {
      delete e.target.dataset.dalenDotsReady;
      init();
    }
  });
})();
